import { providerParser } from '../../models/Provider'
import * as api from '../api'
import useApiMutation from './useApiMutation'

export interface CreateProviderArguments {
  name: string
  global?: boolean
}

export default function useCreateProvider() {
  return useApiMutation({
    mutationFn: async (data: CreateProviderArguments) =>
      providerParser.parse(
        await api.post('provider', {
          name: data.name,
          global: data.global,
        })
      ),
  })
}
